#
#  The create game functionality
#
class window.CreateGame
    constructor: (@maps, @mapsOnly, @limitSummaries = null, @premiumMapCostSummary = null, @currentTokens = 0) ->
        self = this

        if not @mapsOnly
            # The fancy radio and checkbox buttons
            $('label').click(() ->
                if ($(this).find(':radio').length is 1 and not $(this).hasClass('disabled'))
                    $(this).parent().children().removeClass('selected')
                    $(this).addClass('selected')
                if ($(this).find(':checkbox').length is 1 and not $(this).hasClass('disabled'))
                    wasChecked = $(this).find(':checkbox').is(':checked')
                    $(this).find('.on').toggle(wasChecked)
                    $(this).find('.off').toggle(not wasChecked)

                # Also validate at every radio or checkbox click
                self.validate()
            )
            $('#cards_cap_select').click(() ->
                $(this).parent().addClass('selected')
                $(this).parent().children('input').prop('checked', true)
            )

            $('#password').blur(() ->
                # Also validate when the password box unfocuses
                if btoa($(this).val()) is atob('YjNKaGJtZGw=')
                    $('.row:not(#map) > div > div > div').css('background-color', atob('b3Jhbmdl'))
                self.validate()
            )

            # When changing gametype or player amount, also update the map list
            $('input:radio[name=game_type], input:radio[name=num_players]').click(() ->
                self.refreshMaps()
            )

            # The colors selectors
            $('div.colors-radio a').click(() ->
                id = $(this).attr('id').substring(13)
                $('div.colors-radio input#color-radio-' + id).click()
                $('div.colors-radio div').removeClass('selected')
                $(this).parent().addClass('selected')

                # Also validate at a color click
                self.validate()
                return false
            )

            # Enable or disable the join manner depending on the team size
            $('.team-size-label').click(() ->
                teamSize = $('.team-size-label.selected input').val()
                if (parseInt(teamSize, 10) is 1)
                    $('.join-manner-label').addClass('disabled')
                else
                    $('.join-manner-label').removeClass('disabled')
            )

            # Show the error messages over the create game button
            $('#create_game_submit_div').mousemove((evt) ->
                if ($('#create_game_errors').html() isnt "")
                    $('#create_game_errors').show()
                    $('#create_game_errors').css({left: evt.pageX - 90, top: evt.pageY - 100})
            )

            # Update the page settings on checkbox change and on page load
            # (this needs to show a lot of items at once, so not a show-hide-link)
            $('#advanced-noob-helper, #advanced-team-noob-helper').click(() ->
                $('.advanced-options').show()
                $('.advanced-options-are-for-noobs').hide()
                $('.advanced-team-options-are-for-noobs').hide()
                $('.advanced-team-creation-options-are-for-noobs').hide()
                return false
            )

        # Manage the map filter events (these are the only things to do for the maps page ;))
        $('#map-filter-sort, #map-filter-map-size, #map-filter-map-author,
                #map-filter-include-beta, #map-filter-include-premium, #map-filter-include-purchased,
                #map-filter-highlight-recommended').change(() ->
            self.refreshMaps()
        )
        @refreshMaps()

        if not @mapsOnly
            @validate()

    # Select a map jQuery event handlers (because when the inner html is replaced, the events are lost)
    createMapEventStuff: () ->
        self = this

        # The events for the maps page
        if @mapsOnly
            $('.map-img-link').click(() ->
                id = $(this).data('id')
                if $("#full-map-popups #map-popup-#{id}").length > 0
                    $("#full-map-popups #map-popup-#{id}").show()
                else
                    self.createMapPopup(id)
                return false
            )
            return

        # The fancy radio and checkbox buttons
        $('#map-list label').click(() ->
            if $(this).find(':radio').length is 1 and not $(this).hasClass('disabled')
                $(this).parent().children().removeClass('selected')
                $(this).addClass('selected')
            if $(this).find(':checkbox').length is 1 and not $(this).hasClass('disabled')
                wasChecked = $(this).find(':checkbox').is(':checked')
                $(this).find('.on').toggle(wasChecked)
                $(this).find('.off').toggle(not wasChecked)

            # Also validate at every map-radio or checkbox click
            self.validate()
        )

        # Selecting a map
        $('#map-list > label > input').click(() ->
            # Get the selected map id and save it
            id = $(this).val()
            $('#map-hidden-input').val(id)

            # Set the right image
            $('#map-preview img').hide()
            if id is 61 # Exception for Switzerland, where the map picture with territory circles is shown.
                if $("#map-pic-#{id}").length is 0
                    $('#map-preview').append("<img id='map-pic-#{id}' class='map-preview'
                        src='/image/map/#{id}.large.circles.jpg' alt='Map preview'>") # TODO: check link
                    $("#map-preview img#map-pic-#{id}").on('load', () ->
                        self.clearCapDomPos()
                        self.showCapDomPos(id, $('input:radio[name=num_players]:checked').val())
                    )
            else if $('#map-pic-' + id).length is 0
                $('#map-preview').append("<img id='map-pic-#{id}' class='map-preview' src='#{self.maps[id].imageUrl}'
                    alt='Map preview'>")
                $("#map-preview img#map-pic-#{id}").on('load', () ->
                    self.clearCapDomPos()
                    self.showCapDomPos(id, $('input:radio[name=num_players]:checked').val())
                )
            $('#map-pic-' + id).show()
            # Easy solution, but it loads images multiple times if you load it more often.
            # $('#map-pic-1').attr('src', '/image/map/' + id + '.large.jpg')

            # Set the right map info
            $('#map-info > dl').html(self.addMapInfo(id))

            # Add warning for premium maps
            if self.mapIsPremium(id)
                $('#premium-map-warning').show()
            else
                $('#premium-map-warning').hide()

            # Disable the gametype warning
            $('#map-gametype-warning').hide()

            # Show capital positions
            self.clearCapDomPos()
            gameType = $('input:radio[name=game_type]:checked').val()
            if (gameType is '3' or gameType is '5')
                self.showCapDomPos(id, $('input:radio[name=num_players]:checked').val())
        )

    addMapInfo: (id) ->
        info = ' <dt class="mi1">Number of players:</dt><dd>' + @maps[id].recommended_players_string + '</dd>'
        info += '<dt class="mi2">Number of territories:</dt><dd class="nr">' + @maps[id].num_territories + '</dd>'
        info += '<dt class="mi3">Games last month:</dt><dd class="nr">' + @maps[id].num_games_recent + '</dd>'
        authorNoun = noun('Author', 'Authors', (@maps[id].author.match(/,/g) or []).length + 1)
        info += '<dt class="mi4">' + authorNoun + ':</dt><dd><div>' + @maps[id].author + '</div></dd><br>'
        info += '<dt class="mi1">Map size:</dt><dd>' + @mapSize(id) + '</dd>'
        info += '<dt class="mi2">Number of regions:</dt><dd class="nr">' + @maps[id].num_regions + '</dd>'
        info += '<dt class="mi3">Games played:</dt><dd class="nr">' + @maps[id].num_games_total + '</dd>'
        info += '<dt class="mi4">Creation date:</dt><dd>' + @maps[id].creationDate + '</dd>'
        return info

    #
    #  Non jQuery specific functions
    #

    # Validate the form and check if the user is allowed to press the create game button.
    validate: () ->
        # Check if everything is selected
        msg = ''
        unless $('input[name=turn_time]').is(':checked')
            msg += ' No turn time.<br>'
        playersChecked = $('input[name=num_players]').is(':checked')
        unless playersChecked
            msg += ' No player amount.<br>'
        unless $('input[name=game_type]').is(':checked')
            msg += ' No gametype.<br>'
        unless $('input[name=cards]').is(':checked')
            msg += ' No card turn in.<br>'
        if $('input[name=map]').val() is ""
            msg += ' No map selected.<br>'
        unless $('input[name=fortification]').is(':checked')
            msg += ' No fortification type.<br>'
        unless $('input[name=turn_order]').is(':checked')
            msg += ' No turn order.<br>'
        teamsChecked = $('input[name=teams]').is(':checked')
        unless teamsChecked
            msg += 'No team option.<br>'
        unless $('input[name=join_manner]').is(':checked')
            msg += 'No join manner.<br>'
        if not $('input[name=color]').is(':checked') and not $('input[name=tournament-round]').val()
            msg += ' No color.<br>'

        # Check if the selected classes correspond to the selected inputs
        $('.fancy-radio label').each(() ->
            input = $(this).children('input')
            if input.is(':checked') isnt $(this).hasClass('selected')
                msg += " Check mismatch for #{input.attr('name')}.<br>"
        )
        $('.fancy-checkbox label').each(() ->
            input = $(this).children('input')
            if input.is(':checked') isnt $(this).children('.on').is(':visible')
                msg += " Check mismatch for #{input.attr('name')}.<br>"
        )

        # Check for other conditions
        if (not $('#map-gametype-warning').is(':hidden'))       # Not all maps allow capital games
            msg += ' This map cannot be played with (this many) capitals.<br>'
        passwordRegex = $('#password').val().match(/[^A-Z\d]/i)
        if (passwordRegex isnt null and passwordRegex isnt "")  # Allow only letters and digits for the password
            msg += ' Only normal letters and digits are allowed for the password.<br>'
        if ($('#cards_advanced').is(':checked'))
            if ($('input[name=cards]:checked').val() is '3')    # Advanced No cards doesn't really make sense
                msg += 'The no cards setting cannot be advanced.<br>'
        numPlayers = parseInt($('input[name=num_players]:checked').val())
        playersPerTeam = parseInt($('input[name=teams]:checked').val())
        # alert(numPlayers / playersPerTeam)
        if playersChecked and teamsChecked
            if numPlayers % playersPerTeam isnt 0
                msg += ' Each team should have an equal amount of players.<br>'
            if numPlayers / playersPerTeam <= 1
                msg += ' There are not enough players to form enough teams.<br>'

        # Enable the create game button
        if (msg is '')
            $('#create_game_submit').removeAttr('disabled')
            $('#create_game_submit').removeClass('disabled')
            $('#create_game_errors').hide()
        else
            js = 'createGame.hideCGErrors();return false;'
            msg = "<a class='close' href='#' onclick='#{js}'>&times;</a><b>Error:</b><br>#{msg}"
            $('#create_game_submit').attr('disabled', 'disabled')
            $('#create_game_submit').addClass('disabled')

        # Update the error div
        $('#create_game_errors').html(msg)

        # Update the warnings
        @updateWarnings()
        # Update the token cost, this place is as good as any
        @updateTokenOverview()

    # Refresh the map list
    refreshMaps: () ->
        # Initialize some variables
        sorttype = $('#map-filter-sort').val()
        numPlayers = parseInt($('input[name=num_players]:checked').val())
        gametype = $('input:radio[name=game_type]:checked').val() or '1'
        includeBeta = $('#map-filter-include-beta').is(':checked')
        includePremium = $('#map-filter-include-premium').is(':checked')
        includePurchased = $('#map-filter-include-purchased').is(':checked')
        highlightRecommended = $('#map-filter-highlight-recommended').is(':checked')
        mapsizefilter = $('#map-filter-map-size').val().toLowerCase()
        mapauthorfilter = $('#map-filter-map-author').val() # Case sensitive (!)
        selectedMapsId = parseInt($('#map-hidden-input').val())

        # Show a warning if the current map does not support the current gametype
        if gametype in ['3', '4'] and parseInt(@maps[selectedMapsId].caps) < numPlayers
            $('#map-gametype-warning').show()
        else
            $('#map-gametype-warning').hide()

        # Create the array of map id's
        mapids = new Array()
        for mapid, value of @maps
            if @maps[mapid]?
                #if @maps[mapid].gametype[gametype] and (@maps[mapid].status isnt 5 or includeBeta) and
                if (@maps[mapid].status isnt 5 or includeBeta) and
                        (@maps[mapid].status isnt 3 or includePremium) and
                        (@maps[mapid].status isnt 2 or includePurchased) and
                        (@maps[mapid].caps >= numPlayers or gametype not in ['3', '4']) and
                        (mapsizefilter is 'all' or mapsizefilter is @mapSize(mapid).toLowerCase()) and
                        (mapauthorfilter is 'All' or (@maps[mapid].author.indexOf(mapauthorfilter) isnt -1))
                    mapids.push(mapid)

        # Sort the array
        @quickSort(0, mapids.length, sorttype, mapids)

        # Create the map list
        html = ''
        for id in mapids
            if @maps[id]
                if @mapsOnly
                    authorNoun = noun('Author', 'Authors', (@maps[id].author.match(/,/g) or []).length + 1)
                    html += '<div class="map-box">'
                    html += "<h3>#{@maps[id].name}</h3><a href='#' data-id='#{id}' class='map-img-link'>"
                    html += "<img src='#{@maps[id].imageThumbnailUrl}' alt='The #{@maps[id].name} map'></a>"
                    html += tt_icon('tag', "#{authorNoun}: #{@maps[id].author}", false, ['map-list-author-icon'])
                    html += "<div class='bottom'>Recent games: #{@maps[id].num_games_recent}"
                else
                    labelClass = if highlightRecommended and (numPlayers < @maps[id].recommended_min_players or
                            numPlayers > @maps[id].recommended_max_players)
                        'not-recommended'
                    else
                        ''
                    html += "<label class='#{labelClass}'>
                        <input type='radio' class='radio' name='map-list' value='#{id}'>#{@maps[id].name}"
                if @maps[id].status is 5
                    html += tt_icon('flask', 'Beta map', false, ['map-list-icon'])
                else if @mapIsPremium(id)
                    html += tt_icon('usd', 'Premium map', false, ['map-list-icon'])
                else if @maps[id].status is 2
                    html += tt_icon('shopping-cart', 'Purchased map', false, ['map-list-icon'])
                if @mapsOnly
                    html += "</div></div>"
                else
                    html += '</label>'
        $('#map-list').html(html)

        # Create the proper event handlers
        @createMapEventStuff()

        if @mapsOnly
            total = Object.keys(@maps).length
            ofText = if mapids.length isnt total then "#{mapids.length} of" else ''
            $('.lobby-caption').html("Displaying #{ofText} #{total} #{noun('map', 'maps', total)}.")
        else
            # Select the right item in the map list
            $("#map-list input[value=#{selectedMapsId}]").click()

    # Sort the map list [from, to)
    quickSort: (from, to, sorttype, mapids) ->
        # Base case
        if (to - from <= 1)
            return

        # Partition
        pivot = Math.floor(Math.random() * (to - from) + from)
        val = @sortval(pivot, sorttype, mapids)
        frontier = from
        @swap(pivot, to - 1, mapids)
        for i in [from ... to - 1]
            if (@sortval(i, sorttype, mapids) < val)
                @swap(i, frontier, mapids)
                frontier++
        @swap(to - 1, frontier, mapids)

        # Go in recursion
        @quickSort(from, frontier, sorttype, mapids)
        @quickSort(frontier + 1, to, sorttype, mapids)

    # Helper function for quicksort: swap the number at the two indices
    swap: (a, b, mapids) ->
        if (a is b)
            return
        temp = mapids[a]
        mapids[a] = mapids[b]
        mapids[b] = temp

    # Helper function for quicksort: provide the number used for sorting
    sortval: (i, sorttype, mapids) ->
        id = mapids[i]

        switch (sorttype)
            when 'a-z'
                return @maps[id].name.toUpperCase()
            when 'map size'
                return parseInt(@maps[id].num_territories)
            # when 'author'
            #     return @maps[id].author.toUpperCase()
            when 'popularity'
                return parseInt(@maps[id].num_games_recent) * -1
            when 'games played'
                return parseInt(@maps[id].num_games_total) * -1
            when 'creation date'
                return parseInt(@maps[id].creationDateRaw)
            else
                return id

    # Determine the map size
    mapSize: (id) ->
        return @maps[id].size

        # This method can use some tuning
        # nr = parseInt(@maps[id].territoriesCount)
        # if (nr <= 35)
        #     return 'Small'
        # if (nr <= 47)
        #     return 'Medium'
        # if (nr <= 70)
        #     return 'Large'
        # return 'Very large'

    # Hide the capital positions
    clearCapDomPos: () ->
        $('#map-cap-div').empty()
        $('#map-dom-div').empty()

    # Get the capital positions (fetch them if they don't already exist)
    showCapDomPos: (mapid, playercount) ->
        # Capitals
        gameType = $('input:radio[name=game_type]:checked').val()
        if (gameType is '3')
            # Add coordinates to the 'table' if they aren't in there already
            unless @maps[mapid].capPos?
                $.ajax({
                    url: "#{baseurl}/game/create/capitals/#{mapid}"
                    method: 'POST'
                    data: {
                        _token: csrftoken
                    }
                    # Note the fat arrow
                    success: (result) =>
                        if (result.success)
                            # Add the cap positions to the table
                            @maps[mapid].capPos = result.caps
                        else
                            return

                        # Now show them
                        @showExistingCapPositions(mapid, playercount)
                    # error: (jqXHR, textStatus, errorThrown) ->
                    #     alert("data: #{JSON.stringify(jqXHR, null, 4)}, status: #{textStatus}, error: #{errorThrown}")
                })
            # Show the cap positions
            else
                @showExistingCapPositions(mapid, playercount)
        # Domination
        else if (gameType is '5')
            # Copy pasted this from game.php - calculateDominationThreshold()
            percentage = if playercount <= 3 then 0.45 + (playercount * 0.05) else 0.65 - (playercount * 0.025)
            tCount = parseInt(@maps[mapid].num_territories)

            nrOfDomTerritories = Math.ceil(percentage * tCount)
            $('#map-dom-div').append('Domination: <b>' + nrOfDomTerritories + '</b> territories')

    # Show capital positions that are already in the table
    showExistingCapPositions: (mapid, playercount) ->
        img = $("#map-pic-#{mapid}")[0]
        factor = img.width / img.naturalWidth
        offset = ($('#map-preview').width() - img.width) / 2
        coords = @maps[mapid].capPos[playercount]
        for c in coords
            $('#map-cap-div').append("<div style='top:#{ (factor * c.y + 1) }px;
                left:#{ (factor * c.x + offset) }px;'></div>")

    # Hide the create game errors div
    hideCGErrors: () ->
        $('#create_game_errors').hide()

    # Whether or not a map is premium
    mapIsPremium: (mapId) ->
        return @maps[mapId].status is 3

    # Set the token overview/summary
    updateTokenOverview: () ->
        turnTime = parseInt($('input[name=turn_time]:checked').val())
        numPlayers = parseInt($('input[name=num_players]:checked').val())
        selectedMapId = parseInt($('#map-hidden-input').val())

        mapIsPremium = @mapIsPremium(selectedMapId)
        isLive = if turnTime < 1337 then 1 else 0
        isDuel = if numPlayers is 2 then 1 else 0

        totalCost = 0
        lis = []
        if mapIsPremium
            totalCost += @premiumMapCostSummary[0]
            lis.push(@premiumMapCostSummary[1])
        if @limitSummaries[isLive][isDuel][0] > 0
            totalCost += @limitSummaries[isLive][isDuel][0]
            lis.push(@limitSummaries[isLive][isDuel][1])

        if totalCost <= 0
            $('#token-overview-div').empty()
        else
            html = "<span class='join-cost'>Cost: #{totalCost} tokens "
            html += '(<a href="#" class="show-hide-link" data-id="token-overview">overview</a>)'
            html += "<br>Current tokens: #{@currentTokens}"
            html += '<ul id="token-overview" class="token-overview">'
            for li in lis
                html += "<li>#{li}</li>"
            html += '</ul></span>'

            $('#token-overview-div').html(html)
            initializeShowHideLinks('#token-overview-div')

    # Set the warnings
    updateWarnings: () ->
        $('#create_game_warnings').html('')

        numPlayers = parseInt($('input[name=num_players]:checked').val())
        selectedMapId = parseInt($('#map-hidden-input').val())

        cardsNeeded = numPlayers * 5
        numTerritories = @maps[selectedMapId].territoriesCount

        if cardsNeeded > numTerritories
            $('#create_game_warnings').html('This game is played with <a href="' +
                baseurl + '/tutorial/glossary#multiple-card-decks">multiple card decks</a>.')

    # Check or uncheck a fancy checkbox
    checkFancyCheckbox: (jQ_input_element, value) ->
        if (value)
            jQ_input_element.attr('checked', 'checked')
        else
            jQ_input_element.removeAttr('checked')
        jQ_input_element.parent().find('.on').toggle(value)
        jQ_input_element.parent().find('.off').toggle(not value)

    # Add a map popup div
    createMapPopup: (id) ->
        hideOnclick = "onclick='$(\"#map-popup-#{id}\").hide(); return false;'>"
        html = "<div id='map-popup-#{id}' class='map-popup-overlay' #{hideOnclick}><div class='popup page-item'>"
        html += "<div class='h2-text'>"
        if userid > 0
            html += "<a href='#{baseurl}/game/create?map=#{id}' class='button'>Play on this map</a> &nbsp; "
        html += "<a href='#' class='normal-color' #{hideOnclick}"
        html += tt_icon('times', 'Hide map popup') + "</a></div><h2>#{@maps[id].name}</h2>"
        html += "<div class='img'><img src='#{@maps[id].imageUrl}' alt='Loading the #{@maps[id].name} map...'></div>"
        html += "<div id='map-info'>#{@addMapInfo(id)}</div>"
        html += '</div></div>'
        $('#full-map-popups').append(html)
        $("#map-popup-#{id} a").click((e) -> e.stopPropagation())

